import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(
      window.location.hash.slice(1),
    ).get("session_id");
    (async () => {
      try {
        const data = await api(
          "/api/auth/google/session",
          {
            method: "POST",
            body: JSON.stringify({ session_id: sessionId }),
          },
          false,
        );
        setUser(data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        window.history.replaceState(null, "", "/login");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F3F7FB] text-sm font-semibold text-slate-500">
      Memproses masuk Google...
    </div>
  );
}
